import React from "react";
import Menubar from "./Components/Menubar";
import "./App.css";

function App() {
  return (
    <>
      <Menubar />
     
    </>
  );
}

export default App;
